import { Link } from "react-router-dom";
import { havingDeletePermission } from "@/utility/common";
import {
  GetCommonDeleteImgButton,
} from "@/components/Images/CommonImages";


type CreditorsCell = {
  data: {
    creditorName: String;
    totalClaimAmount: Number;
    totalDistributedAmount: Number;
    totalClaims: Number;
    totalVoteAmount: Number;
    creditorId: String;
    isActive: boolean;
    creditorReference: String;
  };
};
export const useCustomCellRenderers = (
  setShowModal: any,
  setActiveClaim: any,
  setCreditor: any,
  Creditor: string[]
) => {
  const caseRenderers = {
    creditorReferenceCellRenderer: function (param: CreditorsCell) {
      return (
        <>
          {
            <Link
              to={`./creditor/${param.data.creditorId}`}
              state={{ from: param.data.creditorId }}
            >
              <span className="text-bold-underline">
                {param.data.creditorReference}
              </span>
            </Link>
          }
        </>
      );
    },
    actionCellRenderers: function (param: CreditorsCell) {
      return (
        <>
          {
            havingDeletePermission(Creditor) && (
              <GetCommonDeleteImgButton
                onClick={() => {
                  setShowModal(true);
                  setActiveClaim(param.data.totalClaims);
                  setCreditor({
                    creditorId: param.data.creditorId,
                    creditorName: param.data.creditorName,
                  });
                }}
                disabled={param.data.isActive === true ? false : true}
              ></GetCommonDeleteImgButton>
            )
            // <CommonTooltipWrapper tooltipTitle={t("global.globalActions.delete")}>
            //  <MotifButton
            //  style={{height:"2rem"}}
            //     variant={DELETE_IMG_VARIANT}
            //     onClick={() => {
            //       setShowModal(true);
            //       setActiveClaim(param.data.totalClaims);
            //       setCreditor({
            //         creditorId: param.data.creditorId,
            //         creditorName: param.data.creditorName,
            //       });
            //     }}
            //     disabled={param.data.isActive === true ? false : true}
            //   >
            //       <MotifIcon
            //           iconFunction={IconoirTrash}
            //           stroke="blue"
            //           strokeWidth="2"
            //           size="24"
            //         />

            //   </MotifButton>

            // </CommonTooltipWrapper>
          }
        </>
      );
    },
  };
  return caseRenderers;
};
